export default __webpack_public_path__ + "static/background-home-xs-d7a1ac06316db2d0334abd3bc19f87ac.png";